import * as React from 'react';

export const noRow = () => {
  return <span></span>;
};
